import { TracksFill24Icon, TrainFill24Icon } from "@vygruppen/spor-icon-react";
import { ColumnSeverityContext } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/ColumnSeverityContext";
import { PlanMeasureKey } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { ComponentProps, FC, useContext } from "react";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import { Flex, Text, tokens } from "shared/components/Spor";
import { useTheme } from "styled-components";

function getTitleForMeasureKey(measureKey: PlanMeasureKey): string {
  switch (measureKey) {
    case "noCoverage":
      return "Uten tiltaksplan";
    case "unpublished":
      return "Påbegynt tiltaksplan";
    case "published":
      return "Publiserte tiltak";
    case "withdrawn":
      return "Tilbaketrukkede tiltak";
  }
}

const CountBadge: FC<{
  semantics: ComponentProps<typeof AlertsCounter>["semantics"];
  alerts: number;
}> = ({ alerts, semantics = "transparent" }) => (
  <AlertsCounter
    alerts={alerts}
    semantics={semantics}
    borderRadius="xxs"
    fontSize={tokens.default.size.spacing[2]}
    height={tokens.default.size.spacing[3]}
    minWidth={tokens.default.size.spacing[3]}
  />
);

type ColumnHeaderProps = {
  measureKey: PlanMeasureKey;
  totalCount: number | undefined;
};

export const ColumnHeader: FC<ColumnHeaderProps> = ({
  measureKey,
  totalCount = 0,
}) => {
  const theme = useTheme();

  const { severityState, countState } = useContext(ColumnSeverityContext);

  const infraSeverity = severityState[measureKey].infrastructure;
  const trainSeverity = severityState[measureKey].train;

  const infraMeasureCount =
    countState[measureKey].infrastructure.alarm +
    countState[measureKey].infrastructure.warning;
  const trainMeasureCount =
    countState[measureKey].train.alarm + countState[measureKey].train.warning;

  return (
    <Flex
      gridRow={1}
      position="sticky"
      p={2}
      borderBottom={`1px solid ${theme.colorOutlineSecondary}`}
      justifyContent="space-between"
      alignItems="center"
    >
      <Text variant="md" fontWeight="bold">
        {getTitleForMeasureKey(measureKey)} ({totalCount})
      </Text>

      <Flex gap={2}>
        {!!infraMeasureCount && (
          <Flex alignItems="center" gap={1}>
            <TracksFill24Icon />
            <CountBadge alerts={infraMeasureCount} semantics={infraSeverity} />
          </Flex>
        )}

        {!!trainMeasureCount && (
          <Flex alignItems="center" gap={1}>
            <TrainFill24Icon />
            <CountBadge alerts={trainMeasureCount} semantics={trainSeverity} />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
